import { useDispatch, useSelector } from "react-redux";

import { setBreadcrumbLabel, resetBreadcrumbLabels } from "store/actions/Breadcrumbs";
import { getBreadcrumbLabels } from "store/selectors/breadcrumbs";

const useBreadcrumbs = () => {
  const dispatch = useDispatch();
  const breadcrumbLabels = useSelector(getBreadcrumbLabels);

  const setLabel = (path, label) => {
    dispatch(setBreadcrumbLabel(path, label));
  };

  const resetLabels = () => {
    dispatch(resetBreadcrumbLabels());
  };

  const getLabel = (path) => {
    return breadcrumbLabels[path] || null;
  };

  return {
    breadcrumbLabels,
    setLabel,
    resetLabels,
    getLabel,
  };
};

export default useBreadcrumbs;
